import React, { Component } from "react";
import "../css/employee.css";
import { Badge, Form, Button, OverlayTrigger, Modal, Glyphicon } from 'react-bootstrap';
import {tooltip} from '../Utils';
import { UserService } from "../Services/UserService";
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

const styles = theme => ({
    fab: {
        margin: theme.spacing.unit,
        position: 'absolute',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
    root: {
      width: '100%',
      marginTop: theme.spacing.unit * 3,
      overflowX: 'auto',
      paddingTop : theme.spacing.unit, 
      paddingLeft: theme.spacing.unit, 
      paddingRight: theme.spacing.unit,
      paddingBottom: theme.spacing.unit
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
    },
    table: {
        minWidth: 700
    },
  });

class Contractor extends Component {

    constructor(props) {
      super(props);
      this.state = {
        data: [],
        originalData: [],
        rows: [],
        new_contractor: { name: "", mobile_no: ""},
        show: false
      }

      this.toggleStatus = this.toggleStatus.bind(this);
      this.createModifyContractor = this.createModifyContractor.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.edit = this.edit.bind(this);
      this.remove = this.remove.bind(this);
      this.handleShow = this.handleShow.bind(this);
      this.handleClose = this.handleClose.bind(this);
    }

    componentWillMount(){
        this.props.setTitle("Contractors");
    }

    componentDidMount(){
        this.fetchData();
    }

    handleClose() {
        this.setState({ show: false });
        this.setState({
            new_contractor: { name: "", mobile_no: ""}
        });
    }

    handleShow() {
        this.setState({ show: true });
    }

    fetchData(){
        this.props.isLoading(true);
        UserService.getContractorList()
        .then((data) => {
            console.log(data);
            this.setState({data: data.users,  originalData: data.users});
            this.updateRows(data.users);
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    updateRows(data){
        let rows = [];
        data.forEach((user) => {
            rows.push(<UserDetails key={user.id} user={user} toggleStatus={this.toggleStatus} edit={this.edit} remove={this.remove}/>);
        });
        this.setState({rows: rows});
    }

    toggleStatus(e,user){
        e.preventDefault();
        UserService.toggleStatus(user.id)
        .then((data) => {
            console.log(data);
            const status = data.status === "0" ? "Deactivated": "Activated";
            this.props.showSnackBar(`${status} contractor ${data.name} Account`, 'info');
            this.fetchData();
        })
        .catch(error => console.log(error));
    }

    filterCriteria(e){
        this.props.isLoading(true);
        if(e)
            e.preventDefault();
        const searchText = this.refs.inputText.value;
        let filteredList = this.state.originalData.filter(data => data.name.toLowerCase().includes(searchText.toLowerCase()));
        if(this.refs.inputText.value.length === 0){
            filteredList = this.state.originalData;
        }
        this.setState({
            data: filteredList,
            message: filteredList.length > 0 ? '' : 'No matching Contractor'
        });
        this.updateRows(filteredList);
        this.props.isLoading(false);
    }

    handleChange(e) {
        e.preventDefault();
        let change = this.state.new_contractor;
        change[e.target.name] = e.target.value;
        this.setState(change);
    }

    createModifyContractor(e){
        e.preventDefault();
        if(this.state.new_contractor.name && this.state.new_contractor.mobile_no){
            this.props.showConfirmDialog("Confirm?", undefined, () => {
                this.createContractorAPI(this.state.new_contractor);
                this.props.closeConfirmDialog();
            });
        } else {
            this.props.showSnackBar(`Please fill all the details and continue`, 'error');
        }
    }

    remove(e, user){
        e.preventDefault();
        if(this.props.user.id !== user.id){
            this.props.showConfirmDialog("Confirm removal of Contractor?", undefined, () => {
                this.removeContractorAPI(this.dialog, user.id);
                this.props.closeConfirmDialog();
            });
        } else {
            this.props.showConfirmDialog("Cannot remove yourself", undefined, undefined);
        }
    }

    removeContractorAPI(dialog, id){
        UserService.removeContractor(id)
        .then((data) => {
            console.log(data);
            this.fetchData();
        })
        .catch((error) => {
            this.props.showConfirmDialog("Could not remove Contractor. Please try again.", undefined, undefined);
        });
        
    }

    edit(e, user){
        e.preventDefault();
        if(user){
            this.setState({new_contractor: user}, function () {
                this.handleShow();
            });
        } else {
            this.handleShow();
        }
    }

    createContractorAPI(new_contractor){
        //new_contractor.code = 1234;
        let body = new_contractor;
        this.props.isLoading(true);
        let headers = {user_id : this.props.user.id };
        UserService.createContractor(headers, body)
        .then((response) => {
            if(response.status === 409){
                this.props.showSnackBar(`Contractor already exists with the same mobile no. Please check again.`, 'error');
            } else {
                console.log(response);
                this.setState({
                    new_contractor: { name: "", mobile_no: ""}
                });
                this.fetchData();
                if(this.state.show) this.handleClose();
            }
            this.props.isLoading(false);
        })
        .catch((error) => {
            this.props.isLoading(false);
            this.props.showConfirmDialog(`Failed to create Contractor. Please try again.`, undefined, undefined);
        });
        
    }

    render() {
        let message = this.state.message;
        const { classes } = this.props;
        return (
            <div className="Home">
                <h3 style={{marginBottom: '20px'}}>Contractors <Badge>{this.state.data.length}</Badge></h3>
                <div className="container">
                    <Paper className={classes.root}>
                        <form onSubmit={(e) => this.filterCriteria(e)} ref="searchForm">
                            <input ref="inputText" type="text" name="searchText" placeholder="Search" onChange={(e) => this.filterCriteria(e)} style={{width: "100%", marginBottom: "10px", padding: "5px", borderColor:"red"}} autoComplete="off"></input>
                        </form>
                        <p style={{color:"red", paddingLeft:"20px"}}>{message}</p>
                            { !message &&
                                <Table className={classes.table}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><Typography variant="title">Name</Typography></TableCell>
                                            <TableCell align="center"><Typography variant="title">Mobile No</Typography></TableCell>
                                            <TableCell align="center"><Typography variant="title">Status</Typography></TableCell>
                                            <TableCell align="center"><Typography variant="title">Created By</Typography></TableCell>
                                            <TableCell align="center"></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.rows}
                                    </TableBody>
                                </Table>
                            }
                    </Paper>
                </div>
                <Modal show={this.state.show} onHide={this.handleClose} style={{marginTop : "5%"}}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.show ? "Contractor" : ""}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.userForm( "Edit Contractor", this.createModifyContractor, "Save")}
                    </Modal.Body>
                </Modal>
                <OverlayTrigger placement="top" overlay={tooltip("Add Contractor")}>
                    <Fab onClick={this.edit} color="primary" aria-label="Add" className={this.props.classes.fab}>
                        <AddIcon />
                    </Fab>
                </OverlayTrigger>
            </div>
        );
    }

    userForm = (title, submitFunction, buttonText, orientation) => (
        <Form {...orientation} className="" onSubmit={submitFunction}>
            <TextField
                id="name"
                label="Name"
                placeholder="Name"
                name="name"
                defaultValue={this.state.new_contractor.name}
                className={this.props.classes.textField}
                margin="normal"
                variant="outlined"
                onChange={this.handleChange}
                required
                fullWidth
                />
            <TextField
                id="mobile_no"
                label="mobile_no"
                placeholder="Mobile no"
                name="mobile_no"
                defaultValue={this.state.new_contractor.mobile_no}
                className={this.props.classes.textField}
                margin="normal"
                variant="outlined"
                onChange={this.handleChange}
                required
                fullWidth
                pattern="[0-9]{10}"
                type="text"
                InputProps={{
                    inputProps: { min: 0, maxLength: 10 }
                }}
            />
            <Button type="submit" onClick={submitFunction} style={{marginRight: "10px"}}>{buttonText}</Button>
            {this.state.show ? (<Button onClick={this.handleClose}>Close</Button>): ""}
        </Form>
    )

}

class UserDetails extends Component {

    render(){
      const user = this.props.user;
        return (
            <TableRow key={user.id} style={{backgroundColor : user.status === "0" ?  "#f6685e" : "#a2cf6e", color: "white"}}>
                <TableCell component="th" scope="row"><Typography variant="subtitle2">{user.name}</Typography></TableCell>
                <TableCell align="center"><Typography variant="subtitle2">{user.mobile_no}</Typography></TableCell>
                <TableCell align="center"><Typography variant="button">{user.status === "0" ? "Deactive" : "Active"}</Typography></TableCell>
                <TableCell align="center"><Typography variant="caption">{user.created_by}</Typography></TableCell>
                <TableCell align="right">
                    <OverlayTrigger placement="bottom" overlay={tooltip("Activate/Deactivate")}>
                        <Glyphicon style={{marginRight: "10px"}} glyph="off" onClick={(e) => this.props.toggleStatus(e, user)}/>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={tooltip("Edit")}>
                        <Glyphicon style={{marginRight: "10px"}} glyph="pencil" onClick={(e) => this.props.edit(e, user)}/>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={tooltip("Remove Contractor")}>
                        <Glyphicon style={{marginRight: "10px"}} glyph="trash" onClick={(e) => this.props.remove(e, user)}/>
                    </OverlayTrigger>
                </TableCell>
            </TableRow>
        );
    }
}

export default withStyles(styles)(Contractor);